import * as types from './unassignedSiteListActionType';

// Unassigned Site List Actions
export const fetchUnassignedSiteListRequest = () => ({
    type: types.FETCH_UNASSIGNED_SITE_LIST_REQUEST
});

export const fetchUnassignedSiteListSuccess = (data) => ({
    type: types.FETCH_UNASSIGNED_SITE_LIST_SUCCESS,
    payload: data
});

export const fetchUnassignedSiteListFailure = (error) => ({
    type: types.FETCH_UNASSIGNED_SITE_LIST_FAILURE,
    payload: error
});

// Practice Dropdown Actions
export const fetchPracticeDropdownRequest = () => ({
    type: types.FETCH_UNASSIGNED_PRACTICE_DROPDOWN_REQUEST
});

export const fetchPracticeDropdownSuccess = (data) => ({
    type: types.FETCH_UNASSIGNED_PRACTICE_DROPDOWN_SUCCESS,
    payload: data
});

export const fetchPracticeDropdownFailure = (error) => ({
    type: types.FETCH_UNASSIGNED_PRACTICE_DROPDOWN_FAILURE,
    payload: error
});

// Sub Practice Dropdown Actions
export const fetchSubPracticeDropdownRequest = () => ({
    type: types.FETCH_UNASSIGNED_SUB_PRACTICE_DROPDOWN_REQUEST
});

export const fetchSubPracticeDropdownSuccess = (data) => ({
    type: types.FETCH_UNASSIGNED_SUB_PRACTICE_DROPDOWN_SUCCESS,
    payload: data
});

export const fetchSubPracticeDropdownFailure = (error) => ({
    type: types.FETCH_UNASSIGNED_SUB_PRACTICE_DROPDOWN_FAILURE,
    payload: error
});

// Save Bulk Practice Site Actions
export const saveBulkPracticeSiteRequest = (payload) => ({
    type: types.SAVE_UNASSIGNED_BULK_PRACTICE_SITE_REQUEST,
    payload: payload
});

export const saveBulkPracticeSiteSuccess = (data) => ({
    type: types.SAVE_UNASSIGNED_BULK_PRACTICE_SITE_SUCCESS,
    payload: data
});

export const saveBulkPracticeSiteFailure = (error) => ({
    type: types.SAVE_UNASSIGNED_BULK_PRACTICE_SITE_FAILURE,
    payload: error
});

// Region/National by Practice Actions
export const fetchPracticeRegionNationalRequest = (payload) => ({
    type: types.FETCH_UNASSIGNED_REGION_NATIONAL_BY_PRACTICE_REQUEST,
    payload
});

export const fetchPracticeRegionNationalSuccess = (payload) => ({
    type: types.FETCH_UNASSIGNED_REGION_NATIONAL_BY_PRACTICE_SUCCESS,
    payload
});

export const fetchPracticeRegionNationalFailure = (error) => ({
    type: types.FETCH_UNASSIGNED_REGION_NATIONAL_BY_PRACTICE_FAILURE,
    payload: error
});
